var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Chrome } from 'vue-color';
import { memoize } from "lodash-es";
import * as S from "./uicore-css-color-widget.module.css";
import makeSchmittTrigger from "../../../../lib/utils/makeSchmittTrigger";
export const getChromeColorPopover = memoize(() => {
  const host = document.createElement('div');
  const host2 = document.createElement('div');
  host.append(host2);
  const inst = new ChromeColorPopover({});
  inst.host = host;
  inst.host.style.position = 'fixed';
  inst.host.style.zIndex = '2000';
  inst.$mount(host2);
  document.body.append(host);
  return inst;
});
// eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
const EmptyColorChangeCallback = color => {};
let ChromeColorPopover = class ChromeColorPopover extends Vue {
  constructor() {
    super(...arguments);
    this.colorValueTemp = '';
    this.internalColorPickerVisible = false;
    this.colorPickerChangeCb = EmptyColorChangeCallback;
  }
  closeColorPopover() {
    this.colorPickerChangeCb = EmptyColorChangeCallback;
    this.colorPickerVisible = false;
  }
  openColorPopover(color, pos, onChange) {
    this.host.style.left = `${pos.x}px`;
    this.host.style.top = `${pos.y}px`;
    this.colorPickerVisible = true;
    this.colorPickerChangeCb = onChange;
    this.colorValueTemp = color;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "style": "visibility: hidden;height:0;width:0"
    }, [h("a-popover", {
      "attrs": {
        "overlayClassName": S.chromeColorPopover,
        "trigger": "click",
        "visible": this.colorPickerVisible,
        "mouseLeaveDelay": 0,
        "placement": "left"
      },
      "on": {
        "visibleChange": visible => {
          if (!visible) {
            this.closeColorPopover();
          }
        }
      }
    }, [h("div", {
      "slot": "content"
    }, [h("chrome-picker", {
      "on": {
        "mouseLeave": () => this.closeColorPopover(),
        "input": e => {
          this.colorValueTemp = e.hex8;
          this.colorPickerChangeCb(e.hex8);
        }
      },
      "attrs": {
        "value": this.colorValueTemp
      }
    })]), h("div", {
      "style": "visibility: hidden;height:0;width:0"
    })])]);
  }
};
ChromeColorPopover = __decorate([Component({
  name: 'ChromeColorPopover',
  components: {
    'chrome-picker': Chrome
  },
  computed: {
    // popover的逻辑本来是点其他位置关闭 但是因为触发按钮不在这个组件里 所以加个延迟关闭
    colorPickerVisible: makeSchmittTrigger('internalColorPickerVisible', 150)
  }
})], ChromeColorPopover);
export { ChromeColorPopover };
//# sourceMappingURL=ChromeColorPopover.js.map
